import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatPrice } from "utils";
import './formality-pricing-details-modal.css';

export default function FormalityPricingDetailsModal({ pricing, onClose }) {
  if (!pricing) return null;

  const deboursTotal = pricing.fpDisbursements?.reduce(
    (sum, d) => sum + Number(d.amount || 0), 0
  ) ?? 0;

  const hasFrais = pricing.fpFees?.length > 0;

  return (
    <Modal show onHide={onClose} centered id="formality-pricing-details-modal">
      <Modal.Header closeButton>
        <Modal.Title>Détail du prix</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Honoraires */}
        <div className="mb-3">
          <div className="fw-bold">Honoraires d'accomplissement de la formalité (*)</div>
          <div className="d-flex justify-content-between">
            <span>Honoraires HT</span>
            <span>{formatPrice(pricing.fpHonorairesET)}€</span>
          </div>
          <div className="d-flex justify-content-between">
            <span>TVA ({pricing.fpHonorairesVATRate} %)</span>
            <span>{formatPrice(pricing.fpHonorairesVATAmount)}€</span>
          </div>
          <div className="d-flex justify-content-between fw-bold">
            <span>Honoraires TTC</span>
            <span>{formatPrice(pricing.fpHonorairesIT)}€</span>
          </div>
          <p className="small text-muted">* Hors prestations de conseil ou de rédaction d'acte</p>
        </div>

        {/* Frais */}
        {hasFrais && (
          <div className="mb-3">
            <div className="fw-bold">Frais</div>
            {pricing.fpFees.map((f, i) => (
              <div key={i} className="d-flex justify-content-between">
                <span>{f.label} HT</span>
                <span>{formatPrice(f.amount)}€</span>
              </div>
            ))}
            <div className="d-flex justify-content-between fw-bold mt-2">
              <span>Total frais TTC</span>
              <span>{formatPrice(pricing.fpFeesIT)}€</span>
            </div>
          </div>
        )}
        {/* Débours */}
        {pricing.fpDisbursements?.length > 0 && (
          <div className="mb-3">
            <div className="fw-bold">Débours (TTC)</div>
            {pricing.fpDisbursements.map((d, i) => (
              <div key={i} className="d-flex justify-content-between">
                <span>{d.label}</span>
                <span>{formatPrice(d.amount)}€</span>
              </div>
            ))}
            <div className="d-flex justify-content-between fw-bold mt-2">
              <span>Total débours</span>
              <span>{formatPrice(deboursTotal)}€</span>
            </div>
          </div>
        )}
        <hr className="my-2" />
        {/* Total */}
        <div className="d-flex justify-content-between fs-6 fw-bold">
          <span>Total TTC</span>
          <span>{formatPrice(pricing.fpTotalPriceIT)}€</span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Fermer</Button>
      </Modal.Footer>
    </Modal>
  );
}
